import LoadingBlocker from '../../components/LoadingSpinner/LoadingBlocker'
import { useEffect } from 'react'
import { useDeleteSessionMutation } from '../../api/api'

const LogoutView = ({ user }) => {
  const [deleteSession] = useDeleteSessionMutation()
  useEffect(() => {
    deleteSession().finally(() => {
      window.location = process.env.REACT_APP_LOGIN_URL
    })
  }, [])

  return (
    <div>
      <LoadingBlocker />
    </div>
  )
}

export default LogoutView
